import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import VideoCard from 'components/Internet_Access/Videos/video-port-forwarding-digitalisierungsbox';
import NavButtons from 'components/Internet_Access/Port_Forwarding/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Port Weiterleitung - Digitalisierungsbox Smart Router",
  "path": "/Fernzugriff/Port_Weiterleitung/Digitalisierungsbox_Smart/Video/",
  "dateChanged": "2017-11-27",
  "author": "Mike Polinowski",
  "excerpt": "Um über die DDNS Adress auf Ihre Kamera zu gelangen, müssen Sie zuerst in Ihrem Internet Router einen Port auf die Kamera durchleiten...",
  "image": "./IA_SearchThumb_Portforwarding_Digitalisierungsbox.png",
  "social": "/images/Search/IA_SearchThumb_Portforwarding_Digitalisierungsbox.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_IA-Port-Forwarding_white.webp",
  "chapter": "Remote Access"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <SEOHelmet title='Port Weiterleitung - Digitalisierungsbox Smart Router' dateChanged='2017-11-27' author='Mike Polinowski' tag='INSTAR IP Camera' description='Um über die DDNS Adress auf Ihre Kamera zu gelangen, müssen Sie zuerst in Ihrem Internet Router einen Port auf die Kamera durchleiten...' image='/images/Search/IA_SearchThumb_Portforwarding_Digitalisierungsbox.png' twitter='/images/Search/IA_SearchThumb_Portforwarding_Digitalisierungsbox.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Internet_Access/Port_Forwarding/Digitalisierungsbox_Smart/' locationFR='/fr/Internet_Access/Port_Forwarding/Digitalisierungsbox_Smart/' crumbLabel="Digitalisierungsbox" mdxType="BreadCrumbs" />
    <NavButtons mdxType="NavButtons" />
    <h1 {...{
      "id": "port-weiterleitung",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#port-weiterleitung",
        "aria-label": "port weiterleitung permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Port Weiterleitung`}</h1>
    <h2 {...{
      "id": "digitalisierungsbox-smart-router",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#digitalisierungsbox-smart-router",
        "aria-label": "digitalisierungsbox smart router permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Digitalisierungsbox Smart Router`}</h2>
    <p>{`Dies ist der 2. Schritt der Portweiterleitung, klicken Sie `}<a parentName="p" {...{
        "href": "/de/Fernzugriff/Der_DDNS_Dienst/"
      }}>{`hier`}</a>{` um zum Anfang der Anleitung zu gelangen.`}</p>
    <EuiSpacer mdxType="EuiSpacer" />
    <VideoCard mdxType="VideoCard" />
    <EuiSpacer mdxType="EuiSpacer" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      